interface TypeStatus {
  key: string;
  name: string;
}

const TYPES_STATUSES = {
  IPROGRESS: 'in_progress',
  IMPLEMENTED: 'implemented',
  ITCOURT: 'implemented_through_court',
  ITINSTANCE: 'implemented_through_instance',
  PI: 'partial_implemented',
  PICOURT: 'partial_implemented_through_court',
  PITINSTANCE: 'partial_implemented_through_instance',
  SUSPENDED: 'suspended'
};

const messageMapping = (type: string) => {
  switch (type) {
    case TYPES_STATUSES.IMPLEMENTED:
      return 'Implementat';
    case TYPES_STATUSES.IPROGRESS:
      return 'În curs de implementare';
    case TYPES_STATUSES.ITCOURT:
      return 'Implementate prin contestație la curte';
    case TYPES_STATUSES.ITINSTANCE:
      return 'Implementată prin constestatie la instanță';
    case TYPES_STATUSES.PI:
      return 'Parțial implementată';
    case TYPES_STATUSES.PICOURT:
      return 'Parțial implementată prin contestație la curte';
    case TYPES_STATUSES.PITINSTANCE:
      return 'Parțial implementată prin contestație la instanță';
    case TYPES_STATUSES.SUSPENDED:
      return 'Suspendat';
  }
};

const types_statuses = [
  { key: 'in_progress', name: 'În curs de implementare' },
  { key: 'implemented', name: 'Implementat' },
  {
    key: 'implemented_through_court',
    name: 'Implementate prin contestație la curte'
  },
  {
    key: 'implemented_through_instance',
    name: 'Implementată prin constestatie la instanța'
  },
  { key: 'partial_implemented', name: 'Parțial implementată' },
  {
    key: 'partial_implemented_through_court',
    name: 'Parțial implementată prin contestație la curte'
  },
  {
    key: 'partial_implemented_through_instance',
    name: 'Parțial implementată prin contestație la instanța'
  },
  { key: 'suspended', name: 'Suspendat' }
];

export { types_statuses, TYPES_STATUSES, messageMapping };
export type { TypeStatus };
